import DatabaseModel from './DatabaseModel.js';
import { unwrapDto } from './responseUtils.js';

const RhFunciones = Object.create(DatabaseModel);

RhFunciones.model = 'rh/funciones';
RhFunciones.modelFront = 'funciones';

// GET /movilidad/rh/funciones[?soloActivas=true][&puestoId=…]
// → lista de { id, codigoInterno, codigo, nombre, activo, puestoId, puestoCodigo,
//              puestoAbreviatura, puestoNombre, puestoActivo, personasVigentes[], avisos[],
//              creadoPor, fechaCreacion, … }
//
// `codigoInterno` (FN-0001) es la identidad de la función y no cambia nunca; `codigo` (F-DIR-49)
// es el que se lee y se puede reordenar (#483). Lo que se guarda como referencia en otras
// pantallas —las funciones de una persona, las reglas de coincidencia— es el interno.
//
// `personasVigentes` son quienes desempeñan hoy la función según la tarjeta «Puesto y funciones»
// de su ficha (#51); quien la finalizó deja de salir el mismo día.
// `PUESTO_INACTIVO` marca una función activa cuyo puesto ya no se ofrece: desactivar un puesto
// no arrastra sus funciones, así que esa combinación es legítima.
RhFunciones.listar = function(soloActivas, puestoId) {
    const self = this;
    const query = [];
    if (soloActivas) query.push('soloActivas=true');
    if (puestoId) query.push('puestoId=' + encodeURIComponent(puestoId));
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + (query.length ? '?' + query.join('&') : ''),
        method: 'GET'
    }, false).then(function(res) {
        return unwrapDto(res) || [];
    });
};

// POST /movilidad/rh/funciones → la función creada. Nace activa.
// `puestoId` es obligatorio y tiene que estar activo: el backend lo rechaza si no.
RhFunciones.crear = function(funcion) {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model,
        method: 'POST',
        data: funcion
    }, false).then(unwrapDto);
};

// PUT /movilidad/rh/funciones/{id} → la función editada: nombre, puesto y código de la función.
// El código INTERNO no se puede cambiar y no hace falta mandarlo.
// Si se cambia de puesto, el backend le pone el siguiente código libre del puesto nuevo, aunque
// se mande otro: el código lleva dentro la abreviatura del puesto y las dos cosas no pueden
// contradecirse (#483).
RhFunciones.editar = function(id, funcion) {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + encodeURIComponent(id),
        method: 'PUT',
        data: funcion
    }, false).then(unwrapDto);
};

// POST /movilidad/rh/funciones/{id}/estado → desactivar o reactivar.
// Reactivar exige que el puesto de la función esté activo; si no, el backend lo explica.
RhFunciones.cambiarActivo = function(id, activo, motivo) {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + encodeURIComponent(id) + '/estado',
        method: 'POST',
        data: { activo: activo, motivo: motivo }
    }, false).then(unwrapDto);
};

// GET /movilidad/rh/funciones/siguiente-codigo?puestoId=… →
//   { puestoId, puestoCodigo, puestoNombre, puestoAbreviatura, codigo, aviso }
// Es lo que rellena solo el campo «Código de la función» al elegir el puesto. Si el puesto no
// tiene abreviatura todavía, `codigo` viene vacío y `aviso` es 'PUESTO_SIN_ABREVIATURA': no es un
// error, es una pieza que falta y la pantalla dice cuál y dónde se completa.
RhFunciones.siguienteCodigo = function(puestoId) {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/siguiente-codigo?puestoId='
            + encodeURIComponent(puestoId),
        method: 'GET'
    }, false).then(unwrapDto);
};

// PUT /movilidad/rh/funciones/codigos → el catálogo entero ya renumerado.
// `codigos` es [{ id, codigo }, …]. Va en una sola transacción, así que es la única forma de
// INTERCAMBIAR dos códigos: de uno en uno, el primer cambio choca siempre con el código del otro.
// Todavía no hay pantalla que lo use: lo usará el asesor IA de la #484, con la aprobación del
// ADMINISTRADOR.
RhFunciones.renumerar = function(codigos, motivo) {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/codigos',
        method: 'PUT',
        data: { codigos: codigos, motivo: motivo }
    }, false).then(function(res) {
        return unwrapDto(res) || [];
    });
};

export default RhFunciones;
